module.exports = __webpack_public_path__ + "img/vue_logo.9a45fc76.svg";